import React from "react";

const Footer = () => (
  <footer className="bg-primary-900 px-4 py-8 text-primary-100">
    © Tinkertax LLP 2021
  </footer>
);

export default Footer;
